module.exports = __webpack_public_path__ + "static/media/4510.afd7306d.jpg";